import { render, staticRenderFns } from "./AssessTable.vue?vue&type=template&id=7dc5fdab&scoped=true"
import script from "./AssessTable.vue?vue&type=script&lang=js"
export * from "./AssessTable.vue?vue&type=script&lang=js"
import style0 from "./AssessTable.vue?vue&type=style&index=0&id=7dc5fdab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc5fdab",
  null
  
)

export default component.exports